import React from "react";
import styled from "@emotion/styled";

import UIcon, { CustomIconKey } from "../../../lib/icons/untitled_ui/UIcon";
import { red75 } from "../../../lib/themes/colors";
import { Flex } from "../../../styles/utility-components";

// Will have more added to it in future
export type NewFeatureType = "bids";

type NewFeatureContent = {
  icon: CustomIconKey;
  bgColor: string;
};

const newFeatureContent: Record<NewFeatureType, NewFeatureContent> = {
  bids: {
    icon: "bidPart",
    bgColor: red75,
  },
};

type Props = {
  NewFeature: NewFeatureType;
};

const NewFeatureTag = ({ NewFeature }: Props) => {
  const { bgColor, icon } = newFeatureContent[NewFeature];
  return (
    <Wrapper bgColor={bgColor}>
      <UIcon size={16} icon={icon} />
      <NewFeatureText>NEW FEATURE</NewFeatureText>
    </Wrapper>
  );
};

const NewFeatureText = styled.div(({ theme }) => ({
  fontFamily: theme.fontFamily,
  fontSize: "12px",
  fontWeight: "500",
  lineHeight: "normal",
}));

const Wrapper = styled(Flex)<{ bgColor: string }>(({ theme, bgColor }) => ({
  height: "28px",
  padding: "4px 8px",
  alignItems: "center",
  gap: "4px",
  borderRadius: "4px",
  color: theme.colors.sysTextDefault,
  backgroundColor: bgColor,
}));

export default NewFeatureTag;
